import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-pers-facts-edit',
  templateUrl: './pers-facts-edit.component.html',
  styleUrls: ['./pers-facts-edit.component.css']
})
export class PersFactsEditComponent implements OnInit {
    persFactsId;

    public edit?: Edit;

    public selectListValueTypes: ValueTypeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.persFactsId = this.stateService.getStateParams()['pers_facts_id'];
    }

    private async loadEdit() {
        if (!!this.persFactsId) {
            this.edit = (await this.datatask.Post(2925, { pers_facts_id: this.persFactsId }))[0];
        }
    }

    private async loadValueTypes() {
        this.selectListValueTypes = await this.datatask.Post(2921);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2926, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2927, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadValueTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    pers_facts_id: number;
    pers_facts_name: string;
    sortorder: string;
    valuetype_no: number;
    isnew: string;
}

interface ValueTypeItem {
    valuetype_no: number;
    valuetype_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('persfactsedit', {
//        templateUrl: 'views/components/views/persfactsedit/persfactsedit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'persFactsEditService', 'factsEditService', function ($stateParams, stateService, modalService, translateService, persFactsEditService, factsEditService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let persFactsId = $stateParams.pers_facts_id;

//            let translations = {
//                error: '',
//                ok: '',
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListValueTypes: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await persFactsEditService.getPersFactsEdit({ pers_facts_id: persFactsId }))[0];
//            }

//            async function loadValueTypes() {
//                vm.model.selectListValueTypes = await factsEditService.listValueTypes();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                persFactsEditService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    persFactsEditService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadValueTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
